// extracted by mini-css-extract-plugin
export default {"about":"About_about__Tj6RT","title":"About_title__mxcVi","container":"About_container__b4cnS","text":"About_text__pM+Sl"};